.ky{color:var(--status-error);}